import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'high-five-icon',
  templateUrl: './high-five-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class HighFiveIconComponent {}
